import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import BranchSelect from 'component/branch/BranchSelect'
import Checkbox from '../Checkbox/newCheckbox'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import DateMonthYearInput from 'component/DateMonthYearInput/DateMonthYearInput'
import HierarchySelect from 'component/hierarchy/HierarchySelectNew'
import PropTypes from 'prop-types'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import Select from '../Select/Select'
import TextField from '../TextField'
import RadioGroup from '../RadioGroup'
import RadioButton from '../Radio'
import 'images/select-arrow.svg'
import moment from 'moment'
import * as menuActions from 'action/menu'
import * as menuMissionActions from 'action/menuMission'
import * as missionsActions from 'action/missions'
import { bindActionCreators } from 'redux'
import LdapInput from '../mobileUpdatesNew/LdapInput'
import { arraysEqual } from 'utils/validations'
import { isEmpty } from '../../utils/validations'
import './formAnalytics.css'
import { browserHistory } from 'react-router'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

/**
 * TIP_SHOW of menus
 */
 const APP_PERMISSION = 1


class Form extends React.Component {
  state = {
    formData: {},
    btnDisabled: false,
    branchs: [],
    branch: false,
    sections: [],
    subtypes:   [],
    subSections: [],
    firstFetch: false,
    selectedWebPermissions : [],
    selectedAppPermissions : [],
    relatoryPermissionsState: [],

    dsLdap: [],
    defaultFilterStore : [],
    prevFormData: {},
    emptyBranchs: 0,
    firstBranchs: false,
    sameFiltersOptions: {
      branchs: false,
      date: false,
      ldap: false,
      period: false,
    }
  }




  async componentDidMount() {

    const formInit = {}
    const defaultDates = [moment().subtract(1, 'month').format(), moment().format()]
    const {isUserMatriz, user, fetchPermissions, fetchMissions, listFiltersGlobal = [] } = this.props
    fetchMissions(user.dsToken)
    fetchPermissions(user.dsToken)

    new Api(user.dsToken).get(API_URL.RELATORY_PERMISSIONS).then(res => this.setState({relatoryPermissionsState: res.data}))


    for (const field of this.props.fields || []) {
      switch (field.type) {
        case 'select_multiple':
        case 'date_range':
        case 'date_month_year':
        case 'sections':
        case 'radio_group':
        case 'subtypes':
          formInit[field.name] = field.initial ? field.initial : []
          break
        case 'hour_range':
          formInit[field.name] = field.initial ? field.initial : ['', '']
          break

        case 'branchs_without_multselect':
          formInit[field.name] = !isUserMatriz ? user.locationCode.padStart(4, '0') : (field.initial ? field.initial : '')
          break
        case 'permission_web':
          this.handleSameFilterOption('web', true)
          break

          case 'permission_app':
            this.handleSameFilterOption('app', true)
            break
        default:
          formInit[field.name] = field.initial ? field.initial : ''
          break
      }

      if (field.type === 'branchs_without_multselect' && formInit[field.name].length > 0) {
        this.setState({ branch: formInit[field.name] })
      }

      if (field.type === 'branchs' && formInit[field.name].length > 0) {
        const branchs = []

        formInit[field.name].forEach((branch) => {
          branchs.push({ value: branch })
        })

        this.setState({ branchs })
      }

      if (['select', 'select_multiple'].indexOf(field.type) !== -1) {
        const obj = {}
        if (typeof field.options === 'function') {
          field.options((options = []) => {
            obj[`select${field.name}`] = options || []
          })
        } else {
          const options = field.options || []
          obj[`select${field.name}`] = options || []
        }
        this.setState(obj)
      }

      if (
        [
          'select_multiple',
          'date',
          'branchs',
          'branchs_without_multselect',
          'sections',
          'date_range',
          'date_month_year',
          'subtypes',
        ].indexOf(field.type) !== -1
      ) {
        const errorObj = {}

        errorObj[`field ${field.name}error`] = false
        errorObj[`field ${field.name}valid`] = false
        this.setState(errorObj)
      }
    }

    formInit.dtRange = defaultDates

    if(!isEmpty(listFiltersGlobal)) {

      this.setState({branchs: listFiltersGlobal.branchs})
      const branchIdList = listFiltersGlobal.branchs
      const dtInit = listFiltersGlobal.dtBegin
      const {dtEnd} = listFiltersGlobal
      const dtRangeGlobal = [dtInit, dtEnd]
      formInit.dtRange = dtRangeGlobal
      let branchs = []
      for (const b of branchIdList || []) {

        if (b.idBranches) {
          branchs.push(...b.idBranches)
        } else if(b.value){
          branchs.push(b.value)
        }
      }

      branchs = branchs.filter((b, p) => branchs.indexOf(b) === p).sort(this.sortBranchs)
      formInit.branchIdList = branchs
      const form = this.state.formData

      form.dtRange = defaultDates

      this.setState({ formData: formInit }, () => {
        this.submit()
      })
      this.setState({ btnDisabled: true })
    }  else {
      browserHistory.push('/analytics-new')
    }



  }

  sortBranchs = (a,b) => a < b ? 1 : -1

   webPermissionsOptions() {

    const webPermissions = this.state.relatoryPermissionsState
    webPermissions.sort((a, b) => {
      if (a.dsChaveMenu < b.dsChaveMenu) return -1
      return 0
    })

    webPermissions.map((p) => ({
    value: p.cdMenu,
    label: p.dsChaveMenu
  }))
}

  handleSameFilterOption(opt,value) {
    this.setState(prevState => ({
      sameFiltersOptions: {
        ...prevState.sameFiltersOptions,
        [opt]: value
      }
    }))
  }

  checkBtnDisable() {
    const { fields } = this.props
    const { formData } = this.state


    for (const field of fields) {

      if(field.type === 'ds_ldap' && formData[field.name]) {

        const oldLdaps = this.state.prevFormData.dsLdaps || []
        const newLdaps = [...formData[field.name]]

        this.handleSameFilterOption('ldap', arraysEqual(oldLdaps, newLdaps))
      }

      if(field.type === 'permission_web' && formData[field.name]) {

        const oldPermissions = this.state.prevFormData.permissions || []
        const newPermissions = [...formData[field.name]]

        this.handleSameFilterOption('web', arraysEqual(oldPermissions, newPermissions))

      }

      if(field.type === 'permission_app' && formData[field.name]) {

        const oldPermissions = this.state.prevFormData.permissions || []
        const newPermissions = [...formData[field.name]]

        this.handleSameFilterOption('app', arraysEqual(oldPermissions, newPermissions))

      }

      if(field.type === 'mission' && formData[field.name]) {

        const onlyValues = (element) => element.value

        const oldMission = this.state.prevFormData.missions || []
        const newMission = [...formData[field.name] || []]

        this.handleSameFilterOption('mission', arraysEqual(oldMission.map(onlyValues), newMission.map(onlyValues)))

      }

      if(field.type === 'date_range' && formData[field.name]) {

        if('dtRange' in this.state.prevFormData && this.state.prevFormData.dtRange.length > 0) {

        const spreadDt = [...formData[field.name], ...this.state.prevFormData.dtRange].map(dt => moment(dt).format('L'))


        const samePeriod = spreadDt[0] === spreadDt[2] && spreadDt[1] === spreadDt[3]

        this.handleSameFilterOption('period', samePeriod)
      }
    }

      if(field.type === 'branchs' && formData[field.name]) {

        const prevIdList = this.state.prevFormData.branchIdList || []
        const sameBranchs = formData[field.name].length === 0 || JSON.stringify(formData[field.name].sort(this.sortBranchs)) === JSON.stringify(prevIdList.sort(this.sortBranchs))

        this.handleSameFilterOption('branchs', sameBranchs)

        }
    }

  }

  submit() {

    const { onSubmit = () => { } } = this.props
    const oldFormData = {...this.state.formData}
    this.setState({prevFormData: oldFormData})

    const sameOpt = Object.keys(this.state.sameFiltersOptions).reduce((accumulator, key) => ({...accumulator, [key]: true}), {});

    this.setState({sameFiltersOptions: sameOpt})

    onSubmit(this.state.formData)
  }

  updateValue(e, props) {
    const form = this.state.formData

    switch (props.type) {
      case 'select_multiple':
        const selected = []
        if (e) {
          for (const o of e) {
            selected.push(o.value)
          }
        }
        form[props.name] = selected
        break
      case 'select':
        form[props.name] = e ? e.value : ''
        break
      case 'checkbox':
        form[props.name] = e ? 1 : 0
        break
      case 'branchs':
        if(this.state.defaultFilterStore.length < 1) {
          this.setState({defaultFilterStore: e.target.value})
        }

        this.setState({ branchs: e.target.value })
        let branchs = []
        for (const b of e.target.value) {
          if (b.idBranches) {
            branchs.push(...b.idBranches)
          } else if(b.value){
            branchs.push(b.value)
          }
          }


        branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)

        form[props.name] = branchs
        break

      case 'permission_web':
        const webPermissions = e ? e.map((o) => o.value) : []
        this.setState({selectedWebPermissions: webPermissions})
        form[props.name] = webPermissions
       break

       case 'permission_app':

        const appPermissions = e || []
        this.setState({selectedAppPermissions: appPermissions})
        form[props.name] = appPermissions.map(o => o.value)
       break
      case 'branchs_without_multselect':
        this.setState({ branch: e.target.value })
        form[props.name] = e ? e.target.value.value : ''
        break

      case 'ds_ldap':
        this.setState({dsLdap: e})
        form[props.name] = e
        break;

      case 'mission':
        form[props.name] = e.map(o => o.label)
        break;

      case 'date_range':
        const dates = []
        if (e) {
          for (const date of e) {
            dates.push(date.format())
          }
        }
        form[props.name] = dates
        break
      case 'date_month_year':
        form[props.name] = e
        break
      case 'radio_group':
        form[props.name] = e
        break
      case 'hour_range':
        form[props.name][e.index] = e.target.value
        break
      case 'input':
      default:
        form[props.name] = e.target.value
        break
    }

    const event = {
      ...e,
    }

    this.setState({ formData: form }, () => {
      if (typeof props.onChangeValue === 'function') {
        props.onChangeValue(event, this.setValueToField)
      }
      setTimeout(() => this.checkBtnDisable(), 150)
    })
  }

  setValueToField = (field, value) => {
    if (this.state.hasOwnProperty(field)) {
      this.setState({
        [field]: value,
      })
    }

    if (this.state.formData.hasOwnProperty(field)) {
      this.setState({
        formData: {
          ...this.state.formData,
          [field]: value,
        },
      })
    }
  }

  buildField(props) {
    const { translate, user, isUserMatriz, permissions, missions, listFiltersGlobal } = this.props
    const { branchs, branch, formData, relatoryPermissionsState } = this.state

    const webPermissions = relatoryPermissionsState.sort((a, b) => {
      if (a.dsChaveMenu < b.dsChaveMenu) return -1
      if (a.dsChaveMenu > b.dsChaveMenu) return 1
      return 0
    })

    const webPermissionsOptions = webPermissions.map((p,index) => ({
      id: index,
      value: p.cdMenu,
      label: p.dsChaveMenu

    }))


    const missionsOptions = missions.map((m) => ({
      value: m.cdMission,
      label: m.dsMission,
    }))

    const appPermissions = permissions.filter(
      (p) => p.tipShow === APP_PERMISSION
    ).filter(a => a.cdMenuParent)

    appPermissions.sort((a, b) => {
      if (a.dsMenuParent < b.dsMenuParent) return -1
      if (a.cdMenuParent > b.cdMenuParent) return 1
      return 0
    })

    const appPermissionsOptions = appPermissions.map((p) => ({
      value: p.cdMenu,
      label: p.dsMenu
    }))

    let field

    switch (props.type) {
      case 'select':
      case 'select_multiple':
        field = this.buildSelect(props)
        break

      case 'checkbox':
        field = (
          <Checkbox
            name={props.name}
            label={props.label}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            checked={props.initial}
            {...props.attrs}
          />
        )
        break

      case 'branchs':
        field = (
          <RegionBranchMultipleSelect
            showInternalServices={this.props.isWeb}
            onChange={(e) => this.updateValue(e, props)}
            placeholder={props.help_text ? props.help_text : ''}
            label={props.label}
            name={'branchs'}
            translate={translate}
            user={user}
            value={branchs}
            required={props.required}
            disabled={!isUserMatriz}

          />
        )
        break

      case 'branchs_without_multselect':
        field = (
          <BranchSelect
            onChange={(e) => this.updateValue(e, props)}
            placeholder={props.help_text ? props.help_text : ''}
            label={props.label}
            name={'branch'}
            translate={translate}
            user={user}
            value={branch}
            required={props.required}
            disabled={!isUserMatriz}
            {...props.attrs}
          />
        )
        break

      case 'sections':
        const { sections } = this.state
        field = (
          <HierarchySelect
            onChange={(e) => this.updateValue(e, props)}
            placeholder={props.help_text ? props.help_text : ''}
            label={props.label}
            required={props.required}
            translate={translate}
            user={user}
            value={sections}
            query={{ level: 2 }}
            name={props.name}
            isMulti
            {...props.attrs}
          />
        )
        break

      case 'permission_app':
        field = (<Select

          label={<span style={{fontWeight: 600, fontStyle: 'normal'}}>{props.label} - <i className='label-analytics'>{translate('optional')}</i> </span> }
          required
          fill
          multiRemove
          closeMenuOnSelect={false}
          isMulti
          onChange={(options) => this.updateValue(options,props)}
          options={webPermissionsOptions}
          placeholder={translate('select.one.relatories')}
          value={webPermissionsOptions.filter((p) =>
            this.state.selectedAppPermissions.some((p2) => p2.value === p.value)
          )}
        />)
        break


      case 'permission_web':
        field = (<Select
          label={<span style={{fontWeight: 600, fontStyle: 'normal'}} >{props.label} - <i className='label-analytics'>{translate('optional')}</i> </span> }
          required
          fill
          closeMenuOnSelect={false}
          isMulti
          onChange={(options) => this.updateValue(options,props)}
          options={appPermissionsOptions}
          placeholder={translate('select.one.funcionalities')}
          value={appPermissionsOptions.filter((p) =>
            this.state.selectedWebPermissions.some((p2) => p2 === p.value)
          )}
        />)
        break


      case 'ds_ldap':
        field = (<LdapInput
              customTitle={<span style={{fontWeight: 600, fontStyle: 'normal'}}>{translate('loginActivity.ldap')} - <i className='label-analytics'>{translate('optional')}</i> </span> }
              values={this.state.dsLdap}
              onChange={(value) => {
                !(this.state.dsLdap || []).some((dsLdap) => dsLdap === value) &&
                  this.updateValue(this.state.dsLdap ? [...this.state.dsLdap, value] : [value], props)

              }}
              removeOption={(index) => {
                const copy = Array.from(this.state.dsLdap)
                copy.splice(index, 1)
                this.updateValue(copy, props)
              }}
              translate={translate}
            />)
            break

        case 'mission':
          field = ( <Select
            label={<span style={{fontWeight: 600, fontStyle: 'normal'}}>{props.label} - <i className='label-analytics'>{translate('optional')}</i> </span> }
            allowCreateWhileLoading={false}
            required
            fill
            isMulti
            onChange={(e) => this.updateValue(e, props)}
            options={missionsOptions}
            placeholder={props.help_text}

          />)
          break;

      case 'date_range':
        field = (
          <NewDateIntervalInput
            t={translate}
            label={props.label}
            user={user}
            defaultLastMonth
            required={props.required}
            showHelperArea={props.showHelperArea}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            options={props.options}
            maxLimitDay={user.isLdapInManager ? false : parseInt(user.reportLimitDaysFilter, 10)}
            {...props.attrs}
            filtersGlobal={!isEmpty(listFiltersGlobal) ? [listFiltersGlobal.dtBegin, listFiltersGlobal.dtEnd] : false}
          />
        )
        break

      case 'hour_range':
        field = (
          <div className='flex flex-row'>
            <div className='margih-right'>
              <TextField
                type='text'
                required={props.required}
                label={translate('query.logs.hourStart')}
                name={props.name}
                onChange={(e) => {
                  this.updateValue({ ...e, index: 0 }, props)
                }}
                value={props.initial ? props.initial[0] : ''}
                placeholder={props.help_text}
                fill
                mask='99:99'
                {...props.attrs}
              />
            </div>
            <div className='margin-left'>
              <TextField
                type='text'
                required={props.required}
                label={translate('query.logs.hourEnd')}
                name={props.name}
                onChange={(e) => {
                  this.updateValue({ ...e, index: 1 }, props)
                }}
                value={props.initial ? props.initial[1] : ''}
                placeholder={props.help_text}
                fill
                mask='99:99'
                validateValue={() => false}
                {...props.attrs}
              />
            </div>
          </div>
        )
        break

      case 'date_month_year':
        field = (
          <DateMonthYearInput
            t={translate}
            label={props.label}
            required={props.required}
            placeholder={props.help_text}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            {...props.attrs}
          />
        )
        break

      default:
        field = (
          <TextField
            type='text'
            required={props.required}
            label={props.label}
            name={props.name}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            value={props.initial ? props.initial : ''}
            placeholder={props.help_text}
            fill
            {...props.attrs}
          />
        )
        break

      case 'radio_group':
        field = (
          <Fragment>
            {props.title && (
              <span className='radio-group-title'>{props.title}</span>
            )}
            <RadioGroup
              className={
                props.title && 'margin-top-small margin-bottom-almost-double'
              }
            >
              {props.options.map((val, i) => (
                <RadioButton
                  key={i}
                  checked={formData[props.name] === val.value}
                  defaultChecked={!!val.checked}
                  onClick={() => this.updateValue(val.value, props)}
                  name={`radioGroup.${props.name}`}
                  label={val.label}
                />
              ))}
            </RadioGroup>
          </Fragment>
        )
    }

    return field
  }

  buildSelect(props) {
    const { translate } = this.props
    const options = this.state[`select${props.name}`] || []

    return (
      <Select
        isMulti={props.type === 'select_multiple'}
        fill
        selectAll
        groupOptions
        required={props.required}
        name={props.name}
        options={options}
        translate={translate}
        label={props.label}
        placeholder={props.help_text}
        onChange={(e) => {
          this.updateValue(e, props)
        }}
        {...props.attrs}
      />
    )
  }

  render() {
    const { translate, buttonCompleteWidth } = this.props
    const {  sameFiltersOptions } = this.state
    const sameOpt = Object.values(sameFiltersOptions).every((v) => v === true)

    return (
      <>
        <form
          className='form-analytics'
          onSubmit={(e) => e.preventDefault()}
          id='report-form'
          noValidate
          autoComplete='off'
        >
          {this.props.fields.map((field, i) => (
            <div key={i} className={field.half ? 'col col-half' : 'col'}>
              {this.buildField(field)}
            </div>
          ))}
          <div className='bottom'>
            <button
              className={`btn btn-primary ${buttonCompleteWidth && 'complete-width'
                }`}
              disabled={this.state.branchs.length === 0 || sameOpt}
              onClick={(e) => this.submit(e)}
            >
              {translate('commonReport.filter')}
            </button>
          </div>
        </form>
      </>
    )
  }
}

Form.propTypes = {
  fields: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  user: PropTypes.object,
  translate: PropTypes.func.isRequired,
  buttonCompleteWidth: PropTypes.bool,
  disableButton: PropTypes.bool,
  isWeb: PropTypes.bool,
  isUserMatriz: PropTypes.bool,
  permissions: PropTypes.array,
  missions: PropTypes.array,
  fetchPermissions: PropTypes.func,
  fetchMissions: PropTypes.func,
  listFiltersGlobal: PropTypes.object
}

const mapStateToProps = ({ auth,menuReducer, missionsReducer, analyticsReducer }) => ({
  isUserMatriz: auth.isUserMatriz,
  user: auth.user,
  permissions: menuReducer.permissions,
  missions: missionsReducer.list,
  listFiltersGlobal: analyticsReducer.listFiltersGlobal.record
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...menuMissionActions, ...menuActions, ...missionsActions },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Form)

export { Form }
